import type { IUser } from 'Model/index.ts'
import { OrganizationType } from 'Model/index.ts'

export const testUser: IUser = {
  email: 'testmail',
  firstName: 'testUser',
  lastName: 'name',
  id: '1',
  authServer: 'foo',
  org: {
    name: 'Hallo',
    id: 'Genomics Lab B',
    type: OrganizationType.LABORATORY,
    isPublic: false,
    defaultSampleConfigurationType: 'SINGLE_SAMPLE_PAIRS',
    isBillingMissing: false,
    defaultRedlistMode: 'DE',
    defaultProcessingType: 'METABARCODING'
  }
}
